<template>
  <v-container>
      <h1>Group Notifications</h1>
      <TasksTable :headers='headers' :queueMessage="Allnotifications" @getUserTask='getAllTasks()' />
  </v-container>
</template>

<script>
import TasksTable from "../components/myTasks/tasksTable"
import { postReq} from '../helper/firestore'

export default {
    components:{
        TasksTable

    },
    data() {
        return {
             headers : [
         { text: 'User email', value: 'userEmail' },
        { text: 'Assigned GC', value: 'gcEmail' },
         { text: 'Time', value: 'time' },
        { text: 'Notification Type', value: 'type' },
            { text: 'Description', value: 'content' },
            { text: 'Action',value: 'action'}
      ],
            Allnotifications : [],
        }
    },
    mounted(){
        this.getAllTasks();
    },
    methods : {
           getAllTasks(){
          postReq(process.env.VUE_APP_ROOT_API_URL + 'api/admin/getAlltasks', {}, result => { 
            if (result.status !== 200) { return }
            this.Allnotifications = result.data
    })
    },
    }
}
</script>

<style>

</style>